import React from "react";
import { Layout } from "../../common/Layout/Layout";
import { LoginForm } from "./LoginForm/LoginForm";

export const Auth = () => {
  return (
    <Layout>
      <LoginForm />
    </Layout>
  );
};
